import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Profile from "../../components/settings/myAccount/Profile";
import Preferences from "../../components/settings/myAccount/Preferences";
import Permissions from "../../components/settings/myAccount/Permissions";
import Notification from "../../components/settings/myAccount/Notification";
import Integration from "../../components/settings/myAccount/Integration";
import Api from "../../components/settings/myAccount/Api";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { loginSessionDetail } from "../../redux/reducers/LoginSessionSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Constants from "../../Constants";
import { getLoggedInUserRole } from "../../services/Util";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import $ from "jquery";

export default function MyAccountProfile() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const owner = useSelector(
    (loginSessionDetail) => loginSessionDetail.loginSession
  ).value;
  const [preferenceEditMode,setPreferenceEditMode] = useState(false)
  const params = useParams();
  const userId = params.id !== undefined ? params.id : owner.id ;
  const [userDetail, setUserDetail] = useState({});
  const [activeTab, setActiveSection] = useState("profile");
  const [backToUserManagement, showBackToUserManagement] = useState(false);
  const [openProfileInEditMode,setProfileInEditMode] = useState(false);
  const roleArray = getLoggedInUserRole();

  const location = useLocation();

  const getUserDetail = () =>{
    getAxiosResponse(APIUrls.GET_FULL_USER_BY_ID_COMBINED(userId))
      .then((res) => {
        setUserDetail(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  useEffect(() => {
    getUserDetail();
    $('.lastdisable').trigger('focus');
  }, []);
  const openProfile = () =>{
    setActiveSection("profile")
    setProfileInEditMode(false)
  }
  const navigateBackToUserList = () => {
    navigate("/settings/user-management");
  };
  const redirectToTab = () =>{
    setPreferenceEditMode(true)
    setActiveSection("preferences")
  }
  const navigateBackToUserListOnKeyDown = (e) => {
    if (e.key === Constants.ENTER) {
      navigateBackToUserList();
    }
  };

  const checkIsEdit = (state) => {
      if(state === true) {
        showBackToUserManagement(true);
      } else {
        showBackToUserManagement(false);
      }
      return (params.id !== undefined);
  }
  const redirectProfileEdit = () =>{
    setActiveSection("profile")
    setProfileInEditMode(true)
  }
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'My Account', url:''},
   ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="my-account-page">
              <div className="project-heading userprofile-heading">
              { params.id !== undefined && backToUserManagement && <div className="back-arrow flex-center">
                  <button aria-label="Back to User Management" onClick={() => navigateBackToUserList()} onKeyDown={(e) => navigateBackToUserListOnKeyDown(e)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                    
                  </button>
                  <span>Back to User Management</span>
                </div>}
                {userDetail?.resource !== undefined ? 
                  (userDetail?.resource?.userId === owner.id) ? 
                    <h3>{translate("my_account.my_account_of")}</h3> :
                      <h3>{userDetail?.resource?.firstName + " " + userDetail?.resource?.lastName + "'s Account"}</h3> : <></>}
                <span>
                  {parseInt(userId) !== parseInt(owner.id) ? "Edit personal information, password, time zone, and other formatting for a user of this OPAL-Marketing account." :
                  "View your personal information, password, time zone, and other formatting."}
                </span>
                {location?.state !== null && <div className="bids-table mar-bot10">
                  <ul>
                    <li>
                      <p className={location?.state?.status === Constants.SUCCESS ? "success-alert m-0" : "error-alert m-0"}>{location?.state?.message}
                      </p>
                    </li>
                  </ul>
                </div>}
                
              </div>
              {parseInt(userId) !== parseInt(owner.id) && activeTab==="notifications" && 
                <div className="bids-table mar-bot10">
                  <ul>
                    <li>
                      <p className="error-alert m-0">Notification Settings are read-only, please login into this User to make any changes.
                      </p>
                    </li>
                  </ul>
                </div>
              }
              <div className="listing-tab-block flex">
                <ul className="listing-tab-link flex" role="tablist">
                  <li role="none">
                    <button
                      role="tab"
                      aria-label={activeTab === "profile" ? "Current tab, Profile" : "Profile"}
                      aria-selected={activeTab === "profile" ? "true" : "false"}
                      className={activeTab === "profile" ? "active" : ""}
                      onClick={openProfile}
                    >
                      Profile
                    </button>
                  </li>
                  <li role="none">
                    <button
                      role="tab"
                      aria-label={activeTab === "preferences" ? "Current tab, Preferences" : "Preferences"}
                      aria-selected={activeTab === "preferences" ? "true" : "false"}
                      className={activeTab === "preferences" ? "active" : ""}
                      onClick={() => setActiveSection("preferences")}
                    >
                      Preferences
                    </button>
                  </li>
                  {!roleArray.includes('ROLE_VENDOR') &&
                  <li role="none">
                    <button
                      role="tab"
                      aria-label={activeTab === "permissions" ? "Current tab, permissions" : "permissions"}
                      aria-selected={activeTab === "permissions" ? "true" : "false"}
                      className={activeTab === "permissions" ? "active" : ""}
                      onClick={() => setActiveSection("permissions")}
                    >
                      Permissions
                    </button>
                  </li>
}
                  {!roleArray.includes('ROLE_VENDOR') &&
                    <li role="none">
                      <button
                        role="tab"
                        aria-label={activeTab === "notifications" ? "Current tab, notifications" : "notifications"}
                        aria-selected={activeTab === "notifications" ? "true" : "false"}
                        className={activeTab === "notifications" ? "active" : ""}
                        onClick={() => setActiveSection("notifications")}
                      >
                        Notifications
                      </button>
                    </li>
                  }
                  {parseInt(userId) === parseInt(owner.id) && <li role="none">
                    <button
                      role="tab"
                      aria-label={activeTab === "API" ? "Current tab, API" : "API"}
                      aria-selected={activeTab === "API" ? "true" : "false"}
                      className={activeTab === "API" ? "active" : ""}
                      onClick={() => setActiveSection("API")}
                    >
                      API
                    </button>
                  </li>}
                </ul>
              </div>
              <div className="white-bg">
                <div
                  className={
                    activeTab === "profile"
                      ? "profile-tab-content show"
                      : "hide"
                  }
                >
                 { activeTab === "profile" ? <Profile user={userDetail} isEdit={checkIsEdit} funct={getUserDetail} openEdit={openProfileInEditMode} redirectTab={redirectToTab}/> : null}
                </div>

                <div
                  className={
                    activeTab === "preferences"
                      ? "preferences-tab-content show"
                      : "hide"
                  }
                >
                  {activeTab === "preferences" ? <Preferences user={userDetail} funct={getUserDetail} editMode={preferenceEditMode}/> : null}
                </div>


                <div
                  className={
                    activeTab === "permissions"
                      ? "permissions-tab-content show"
                      : "hide"
                  }
                >
                 { activeTab === "permissions" ?  <Permissions user={userDetail} funct={getUserDetail}/> : null}
                </div>
                <div
                  className={
                    activeTab === "notifications"
                      ? "notifications-tab-content show"
                      : "hide"
                  }
                >
                   { activeTab === "notifications" ?   <Notification user={userDetail} funct={getUserDetail} redirect={redirectProfileEdit}/> : null}
                 
                </div>
                {parseInt(userId) === parseInt(owner.id) && <div
                  className={
                    activeTab === "API" ? "API-tab-content show" : "hide"
                  }
                >
                  { activeTab === "API" ?   <Api user={userDetail} funct={getUserDetail}/> : null}
                </div>}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
